<template>
  <div id="tip_dialogModal">
    <div class="t-dialog-mask"></div>
    <div class="t-dialog-container">
      <div class="t-dialog-title">
        <span>
          {{title}}
        </span>
      </div>
      <div class="t-dialog-content">
        <span class="content-text">
          {{content}}
        </span>
      </div>
      <div class="t-dialog-confirm">
        <button @click="confirm">确定</button>
        <!-- 默认是没有取消按钮的，data定义默认true false -->
        <button class="cancel-btn" v-show="cancelBtn" @click="cancel">取消</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      show: true, // 通过这个属性，控制是否移除dom元素
      title: '', // 顶部标题
      content: '', // 内容
      cancelBtn: false // 取消按钮
    }
  },
  methods: {
    confirm () {
      // 确定
      this.a_confirm && this.a_confirm()
      this.show = false
      // 删除判断增加的window属性
      delete window.dialogIsShow
    },
    cancel () {
      // 取消
      this.a_cancel && this.a_cancel()
      this.show = false
      // 删除判断增加的window属性
      delete window.dialogIsShow
    }
  },
  watch: {
    show (cur, old) {
      // 通过监控data里的show属性  弹框有三个事件（右上角取消  确定按钮  取消按钮）
      // 每个事件写了 this.show = false
      // 当弹框出现的时候 点击任何一个事件  都会触发这里的监控事件  将页面上的弹框Dom移除
      if (cur === false) {
        // eslint-disable-next-line camelcase
        let tip_dialog = document.getElementById('tip_dialogModal')
        tip_dialog.parentNode.removeChild(tip_dialog)
      }
    }
  }
}
</script>
<style scoped>
#tip_dialogModal {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 3000;
  width: 100%;
  height: 100%;
}
#tip_dialogModal .t-dialog-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}
#tip_dialogModal .t-dialog-container {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 240px;
  max-width: 400px;
  height: auto;
  background-color: #fff;
  transform: translate(-50%, -50%);
  border-radius: 4px;
}
#tip_dialogModal .t-dialog-container .t-dialog-title {
  position: relative;
  width: 100%;
  height: 40px;
  line-height: 40px;
  background-color: #0080cc;
  border-radius: 4px 4px 0px 0px;
}
#tip_dialogModal .t-dialog-container .t-dialog-title span {
  position: absolute;
  top: 50%;
  left: 50%;
  font-weight: 500;
  font-size: 16px;
  color: #fff;
  transform: translate(-50%, -50%);
}
#tip_dialogModal .t-dialog-container .t-dialog-title img {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translate(0, -50%);
  cursor: pointer;
}
#tip_dialogModal .t-dialog-container .t-dialog-content {
  text-align: center;
}
#tip_dialogModal .t-dialog-container .t-dialog-content span {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}
#tip_dialogModal .t-dialog-container .t-dialog-content span.content-text {
  display: inline-block;
  height: auto;
  font-weight: 400;
  font-size: 14px;
  color: #333;
  padding: 20px 18px;
}
#tip_dialogModal .t-dialog-container .t-dialog-content .t-content-list {
  min-width: 320px;
  height: auto;
  text-align: left;
}
#tip_dialogModal .t-dialog-container .t-dialog-content .t-content-list .list-title {
  position: relative;
  padding: 10px 0 10px 10px;
}
#tip_dialogModal .t-dialog-container .t-dialog-content .t-content-list .list-title img {
  display: inline-block;
  position: absolute;
  width: 20px;
  margin-right: 10px;
}
#tip_dialogModal .t-dialog-container .t-dialog-content .t-content-list .list-title span {
  display: inline-block;
  vertical-align: middle;
  padding-left: 31px;
}
#tip_dialogModal .t-dialog-container .t-dialog-content .t-content-list .list-content {
  width: 100%;
  height: auto;
}
#tip_dialogModal .t-dialog-container .t-dialog-content .t-content-list .list-content ul {
  padding-bottom: 10px;
}
#tip_dialogModal .t-dialog-container .t-dialog-content .t-content-list .list-content ul li {
  width: 100%;
  height: auto;
  padding-bottom: 10px;
}
#tip_dialogModal .t-dialog-container .t-dialog-content .t-content-list .list-content ul li span {
  vertical-align: top;
}
#tip_dialogModal .t-dialog-container .t-dialog-content .t-content-list .list-content ul li span.title {
  display: inline-block;
  padding-left: 41px;
  padding-right: 3px;
  text-align: left;
}
#tip_dialogModal .t-dialog-container .t-dialog-confirm {
  width: 100%;
  padding-bottom: 17px;
  text-align: center;
}
#tip_dialogModal .t-dialog-container .t-dialog-confirm button {
  display: inline-block;
  width: 80px;
  height: 36px;
  border: none;
  background: #0080cc;
  font-weight: 400;
  font-size: 16px;
  color: #fff;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
}
#tip_dialogModal .t-dialog-container .t-dialog-confirm .cancel-btn {
  margin-left: 20px;
  background: #97c1ea;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
}

</style>



// WEBPACK FOOTER //
// src/components/Dialog/Dialog.vue